<template>

</template>

<script>
export default {
  name: 'PostFormMentionsLegalesManage'
}
</script>

<style scoped>

</style>
